import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { faAngleRight, faPlus, faTimes } from '@fortawesome/free-solid-svg-icons';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { iacOptionInterface } from 'src/app/page_component_item/input-with-autocomplete/input-with-autocomplete.component';
import { ciInterface } from 'src/app/util/interfaces/ci';
import { ciTypesInterface } from 'src/app/util/interfaces/ciTypes';
import { genericFormInterface } from 'src/app/util/interfaces/genericForm';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { CmdbSearchFilterService } from './service/cmdb-search-filter.service';
import { mspTableHeaderI } from 'src/app/page_component_item/msp-table/msp-table.component';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';

@Component({
	selector: 'pcp-cmdb-search-filter',
	templateUrl: './cmdb-search-filter.component.html',
	styleUrls: ['./cmdb-search-filter.component.scss'],
})
export class CmdbSearchFilterComponent implements OnInit, OnChanges {
	icons = {
		faTimes: faTimes,
		faAngleRight: faAngleRight,
		faPlus: faPlus,
	};

	labels: LabelsInterface = {
		lbl_geral_selecione: 'SELECT',
		lbl_geral_nao: 'No',
		lbl_geral_sim: 'Yes',
		lbl_geral_todos: 'All',
		lbl_geral_pesquisar: 'Pesquisar',
		lbl_security_nenhum_registro: '',
		lbl_filtros_de_busca: 'Search filters',
		lbl_aqui_resultados_filtros_cima: '',
		lbl_adicionar_filtros_personalizados: '',
		lbl_nenhum_filtro_selecionado: '',
		lbl_insira_um_filtro: '',
		lbl_geral_itens: '',
		lbl_max_100_itens_filtre_itens_especificos: '',
		lbl_geral_contendo: '',
		lbl_geral_diferente_de: '',
		lbl_geral_parar: 'Stop',
		lbl_geral_ler: 'Read',
		lbl_geral_qrcode: 'QrCode',
		lbl_geral_barcode: 'Bar code',
		lbl_carregando_cis_legados:
			'We are dealing with some legacy CI that need to be imported, this search may take longer than normal, please wait',
	};

	searchHeader: mspTableHeaderI[] = [
		{ name: 'identification', value: 'lbl_geral_identificacao', colType: 'text' },
		{ name: 'type', value: 'lbl_asset_tipo_ci', colType: 'text' },
	];

	timeoutTimer = 20_000;

	constructor(
		private CmdbSearchFilterService: CmdbSearchFilterService,
		private LabelsService: LabelsService,
		private NotificationService: NotificationService,
		private ProfileService: ProfileService
	) {}

	isLoadingLabels = true;
	isLoadingAvailableFilters = true;
	isLoadingCiList = false;
	isLoadingCiType = false;

	availableCmdbFilters: genericFormInterface[] = [];
	availableCmdbFiltersIAC: iacOptionInterface[] = [];

	@Input()
	customer = '';

	@Input()
	instaSelectFilters: { name: string; values: any; lock: boolean; unchangeable: boolean; operator?: string }[] = [];

	@Input()
	hideFilters: string[] = [];

	//É hideItemsFilters usada para receber uma lista de filtros ou identificadores de itens que devem ser ocultados ou removidos de uma lista, conforme necessário.
	@Input()
	hideItemsFilters: any[] = [];

	@Input()
	selectedFilters: genericFormInterface[] = [];

	@Input()
	ciType: ciTypesInterface = { id: '', name: '', label: '', type: '' };

	@Input()
	allowedCiType: number[] = [];

	@Input()
	cleanComponent = false;

	ciList: ciInterface;
	ciListIAC: iacOptionInterface[];

	@Output()
	getSelectedCi = new EventEmitter();

	@Output()
	getSelectedFilters = new EventEmitter();

	//Config
	@Input()
	searchCis = true;
	@Input()
	multiOptionSelect = false;
	@Input()
	keepSelectedCi = true;

	readingQrCode = false;
	readingBarCode = false;

	ngOnInit(): void {
		this.LabelsService.getLabels().subscribe((labels) => {
			this.labels = labels;
			this.isLoadingLabels = false;
		});

		if (this.customer == '') this.customer = this.ProfileService.userData().idCustomer;

		//Hidding those until a new qr/bar reader and writter is implemented;
		this.hideFilters.push('qrcode', 'barcode');
		this.getFilterAndCi(this.customer, this.ciType.id ? this.ciType.id : null, true);
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes && changes.cleanComponent && changes.cleanComponent.currentValue === true) {
			this.resetComponent();
		}
	}

	getFilterAndCi(idCustomer: string, ciTypeId?: string, isFirstTime?: boolean): void {
		this.isLoadingAvailableFilters = true;

		if (ciTypeId) {
			this.isLoadingCiType = true;
			this.CmdbSearchFilterService.getCiType(ciTypeId).subscribe((ciType) => {
				this.ciType = ciType;

				for (const [index, selectedFilter] of this.selectedFilters.entries()) {
					if (selectedFilter.commonGroup != '1A') {
						this.selectedFilters.splice(index, 1);
					}
				}

				this.isLoadingCiType = false;
			});
		}

		this.CmdbSearchFilterService.getAvailableFilters(idCustomer, this.allowedCiType, ciTypeId ? ciTypeId : this.ciType.id).subscribe(
			(availableCmdbFilters) => {
				this.availableCmdbFilters = availableCmdbFilters;
				for (const cmdbFilters of this.availableCmdbFilters) {
					this.handleMockSelectedFilters(ciTypeId, cmdbFilters);
					if (this.hideFilters.includes(cmdbFilters.name)) {
						cmdbFilters.hidden = true;
					}

					// Se houver filtros para ocultar items
					if (this.hideItemsFilters.length > 0) {
						// Itera por cada item no array 'items' do filtro atual (cmdbFilters)
						for (const [index, item] of cmdbFilters.items.entries()) {
							// Verifica se o nome do item está presente na lista de filtros para ocultar (hideItemsFilters)
							if (this.hideItemsFilters.includes(item.name)) {
								// Remove o item do array 'items' do filtro atual (cmdbFilters) caso esteja na lista de filtros para ocultar
								cmdbFilters.items.splice(index, 1);
							}
						}
					}

					if (cmdbFilters.name === 'qrcode' || cmdbFilters.name === 'barcode') {
						cmdbFilters.inputType = 'readCode';
					}

					if (isFirstTime) {
						for (const [index, instaSelectFilters] of this.instaSelectFilters.entries()) {
							if (cmdbFilters.name === instaSelectFilters.name) {
								cmdbFilters.undeletable = instaSelectFilters.lock;
								cmdbFilters.unchangeable = instaSelectFilters.unchangeable;
								cmdbFilters.operator = instaSelectFilters.operator;

								this.selectedFilters.push(cmdbFilters);
								this.handleMultiOptionValue(index, instaSelectFilters.values, true);
							}
						}
					}
				}

				if (this.selectedFilters && this.selectedFilters.length > 0) {
					const temporarySelectedFilters = [...this.selectedFilters];
					const temporaryAvailableFilters = [...this.availableCmdbFilters];
					this.selectedFilters = [];

					for (const availableFilter of temporaryAvailableFilters) {
						for (const selectedFilters of temporarySelectedFilters) {
							if (availableFilter.name === selectedFilters.name) {
								availableFilter.outItems = selectedFilters.outItems;
								availableFilter.values = selectedFilters.values;
								availableFilter.operator = selectedFilters.operator;

								for (let index = 0; index < availableFilter.items.length; index++) {
									for (let index_ = 0; index_ < availableFilter.outItems.length; index_++) {
										if (availableFilter.items[index].name === availableFilter.outItems[index_].name) {
											availableFilter.items.splice(index, 1);
											index--;
											break;
										}
									}
								}

								this.setTag(`${availableFilter.name},${availableFilter.commonGroup}`);
							}
						}
					}
				}

				if (isFirstTime && (ciTypeId || (this.ciType && this.ciType.id))) {
					for (const availableFilter of this.availableCmdbFilters) {
						if (availableFilter.commonGroup === '1A' && availableFilter.name === 'type') {
							availableFilter.values[0] = ciTypeId ? ciTypeId : this.ciType.id;
							this.setTag(`${availableFilter.name},${availableFilter.commonGroup}`);
							break;
						}
					}
				}

				this.availableCmdbFiltersIAC = this.convertFilterToIAC(this.availableCmdbFilters);

				if (this.searchCis && isFirstTime && (ciTypeId || (this.ciType && this.ciType.id))) {
					this.isLoadingCiList = true;

					this.CmdbSearchFilterService.getCiList(this.customer, this.allowedCiType, this.selectedFilters).subscribe(
						(ciListRes) => {
							this.isLoadingCiList = false;
							this.ciList = ciListRes;
							this.ciListIAC = [];
							for (let index = 0; index < ciListRes.ciArray.length; index++) {
								const ci = ciListRes.ciArray[index];

								const iacOption: iacOptionInterface = {
									name: ci.identification,
									value: ci.cmdb_id,
									commonGroup: '',
								};
								if (this.ciType && this.ciType.id === '') {
									iacOption.commonGroup = ci.type;
								}
								this.ciListIAC.push(iacOption);
							}
						},
						(errorRes) => {}
					);
				}

				this.isLoadingAvailableFilters = false;
			}
		);
	}

	convertFilterToIAC(genericForm: genericFormInterface[]): iacOptionInterface[] {
		const returnIAC: iacOptionInterface[] = [];
		for (const filter of genericForm) {
			if (filter.hidden) continue;

			const newFilterIAC: iacOptionInterface = {
				name: this.labels[filter.label] ? this.labels[filter.label] : filter.name,
				value: `${filter.name},${filter.commonGroup}`,
				commonGroup: filter.commonGroup,
			};

			returnIAC.push(newFilterIAC);
		}

		returnIAC.sort((a, b) => {
			if (a.name > b.name) return 1;
			if (a.name < b.name) return -1;
			return 0;
		});

		returnIAC.sort((a, b) => {
			if (a.commonGroup > b.commonGroup) return 1;
			if (a.commonGroup < b.commonGroup) return -1;
			return 0;
		});

		return returnIAC;
	}

	setTag(tagValue: string): void {
		for (const [index, filter] of this.availableCmdbFilters.entries()) {
			if (tagValue === `${filter.name},${filter.commonGroup}`) {
				this.selectedFilters.push(filter);
				this.availableCmdbFilters.splice(index, 1);
				this.availableCmdbFiltersIAC = [];
				this.emitSelectedFilters();
				setTimeout(() => {
					this.availableCmdbFiltersIAC = this.convertFilterToIAC(this.availableCmdbFilters);
				}, 1);

				continue;
			}
		}
	}

	deleteTag(tagIndex: number): void {
		this.availableCmdbFilters.push(this.selectedFilters[tagIndex]);

		if (this.selectedFilters[tagIndex].name == 'qrcode') {
			this.readingQrCode = false;
		}
		if (this.selectedFilters[tagIndex].name == 'barcode') {
			this.readingBarCode = false;
		}

		if (this.selectedFilters[tagIndex].commonGroup === '1A' && this.selectedFilters[tagIndex].name === 'type') {
			this.ciType = { id: '', name: '', label: '', type: '' };
			for (const [index, selectedFilter] of this.selectedFilters.entries()) {
				if (selectedFilter.commonGroup != '1A') {
					this.selectedFilters.splice(index, 1);
				}
			}
			this.getFilterAndCi(this.customer);
		}

		this.selectedFilters.splice(tagIndex, 1);
		this.availableCmdbFiltersIAC = [];
		this.emitSelectedFilters();
		setTimeout(() => {
			this.availableCmdbFiltersIAC = this.convertFilterToIAC(this.availableCmdbFilters);
		}, 1);
	}

	updateFilters(): void {
		if (this.isLoadingCiList) return;

		if (this.selectedFilters && this.selectedFilters.length === 0 && this.ciType.id === '') {
			this.NotificationService.setNotificationMessage(this.labels.lbl_insira_um_filtro);
			return;
		}

		this.isLoadingCiList = true;
		this.CmdbSearchFilterService.getCiList(this.customer, this.allowedCiType, this.selectedFilters).subscribe(
			(ciListRes) => {
				this.ciList = ciListRes;
				this.ciListIAC = [];
				for (let index = 0; index < ciListRes.ciArray.length; index++) {
					if (!this.hideItemsFilters.includes(ciListRes.ciArray[index].type)) {
						const ci = ciListRes.ciArray[index];

						const iacOption: iacOptionInterface = {
							name: ci.identification,
							value: ci.cmdb_id,
							commonGroup: '',
						};
						if (this.ciType && this.ciType.id === '') {
							iacOption.commonGroup = ci.type;
						}
						this.ciListIAC.push(iacOption);
					}
				}
				this.isLoadingCiList = false;
			},
			(errorRes) => {
				this.ciListIAC = [];
				this.isLoadingCiList = false;
			}
		);
	}

	resetComponent(): void {
		for (const selectedFilter of this.selectedFilters) {
			selectedFilter.values = [''];
			for (const outItem of selectedFilter.outItems) {
				selectedFilter.items.push(outItem);
			}
			selectedFilter.outItems = [];

			selectedFilter.items.sort((a, b) => {
				if (this.labels[a.label] && this.labels[b.label]) {
					if (this.labels[a.label] > this.labels[b.label]) return 1;
					if (this.labels[a.label] < this.labels[b.label]) return -1;
				} else {
					if (a.name > b.name) return 1;
					if (a.name < b.name) return -1;
				}
				return 0;
			});

			this.availableCmdbFilters.push(selectedFilter);
			this.selectedFilters.shift();
		}
		this.availableCmdbFiltersIAC = [];
		this.emitSelectedFilters();
		setTimeout(() => {
			this.availableCmdbFiltersIAC = this.convertFilterToIAC(this.availableCmdbFilters);
		}, 1);
		this.ciType = { id: '', name: '', label: '', type: '' };
		this.ciListIAC = null;
	}

	notify(text: string): void {
		this.NotificationService.setNotificationMessage(text);
	}

	emitSelectedCi(selectedCiValue): void {
		for (const index in this.ciList.ciArray) {
			const ci = this.ciList.ciArray[index];
			if (ci.cmdb_id === selectedCiValue) {
				this.getSelectedCi.emit(JSON.stringify(ci));
				break;
			}
		}
	}

	emitSelectedFilters(): void {
		this.getSelectedFilters.emit(this.selectedFilters);
	}

	handleMockSelectedFilters(ciTypeId: string, field: genericFormInterface): void {
		if (ciTypeId && (ciTypeId.toString() == '3' || ciTypeId.toString() === '4') && field.name === 'version') {
			field.inputType = 'select';
			field.hidden = false;
		}
	}

	hideFilter(filterName: string): void {
		for (let index = 0; index < this.availableCmdbFilters.length; index++) {
			if (this.availableCmdbFilters[index].name === filterName) {
				this.availableCmdbFilters[index].hidden = true;
				this.availableCmdbFilters[index].required = false;
				break;
			}
		}
	}

	//If notAnEvent flag is true, it means the 'event' is actually
	//the value directly and not an event from html
	handleMultiOptionValue(index: number, event: any, notAnEvent?: boolean): void {
		if (
			index === undefined ||
			index < 0 ||
			(!notAnEvent && !event.target.value) ||
			(!notAnEvent && event.target.value.toString().trim() === '' && notAnEvent && !event)
		)
			return;

		const selectedFilter = this.selectedFilters[index];

		if (selectedFilter.inputType === 'select' || selectedFilter.inputType === 'boolean') {
			for (let index_ = 0; index_ < selectedFilter.items.length; index_++) {
				const item = selectedFilter.items[index_];
				if (item.values[0].toString() != (notAnEvent ? event.toString() : event.target.value.toString())) continue;

				selectedFilter.outItems.push(item);
				selectedFilter.items.splice(index_, 1);
				selectedFilter.values.push(notAnEvent ? event : event.target.value);
				break;
			}
		}

		if (
			selectedFilter.inputType === 'date' ||
			(selectedFilter.inputType === 'readCode' && notAnEvent) ||
			((selectedFilter.inputType === 'readCode' || selectedFilter.inputType === 'string' || selectedFilter.inputType === 'number') &&
				event.type === 'change')
		) {
			selectedFilter.values[0] = notAnEvent ? event : event.target.value;
			selectedFilter.outItems.push(notAnEvent ? event : event.target.value);
			selectedFilter.values.push(notAnEvent ? event : event.target.value);
			setTimeout(() => {
				selectedFilter.values[0] = '';
			}, 1);
		}
	}

	removeMultiOptionValue(fieldIndex: number, itemIndex: number): void {
		const selectedFilter = this.selectedFilters[fieldIndex];

		if (selectedFilter.inputType === 'select' || selectedFilter.inputType === 'boolean') {
			selectedFilter.items.push(selectedFilter.outItems[itemIndex]);
			selectedFilter.outItems.splice(itemIndex, 1);
			selectedFilter.values.splice(itemIndex + 1, 1);

			selectedFilter.items.sort((a, b) => {
				if (this.labels[a.label] && this.labels[b.label]) {
					if (this.labels[a.label] > this.labels[b.label]) return 1;
					if (this.labels[a.label] < this.labels[b.label]) return -1;
				} else {
					if (a.name > b.name) return 1;
					if (a.name < b.name) return -1;
				}
				return 0;
			});
		}

		if (
			selectedFilter.inputType === 'date' ||
			selectedFilter.inputType === 'string' ||
			selectedFilter.inputType === 'number' ||
			selectedFilter.inputType === 'readCode'
		) {
			selectedFilter.outItems.splice(itemIndex, 1);
			selectedFilter.values.splice(itemIndex + 1, 1);
		}
	}
}
